const EmployerArea = (submitData:any) => {
    return `${submitData.employerStreetAdress}, ${submitData.employerZipcode}, ${submitData.employerCity}`;
};

export default EmployerArea;